import { useContrastQuery } from '../../hooks/use-contrast-query'
import { Query } from '../../hooks/queries'
import {
  getRouteObservations,
  RouteObservationsQueryArgs,
  RouteObservationResponse
} from './api/route-observations'

export function useRouteObservations(
  organizationUuid: string,
  applicationUuid: string,
  routeHash: string,
  agentSessionId?: string[]
) {
  return useContrastQuery<RouteObservationsQueryArgs, RouteObservationResponse>(
    [Query.ROUTE_OBSERVATIONS, applicationUuid, routeHash],
    getRouteObservations,
    {
      organizationUuid,
      applicationUuid,
      routeHash,
      agentSessionId
    },
    { cacheTime: 0 }
  )
}
